import React, { useState, useSyncExternalStore } from "react";
import { useNavigate } from "react-router-dom";
import {
    getUnauthorizedAccess,
    subscribeUnauthorizedAccess,
} from "../../Common/Axios/unauthorizedAccess";
import icon from "../../Assets/sessionExpired.svg";
import CloseIcon from "../../Assets/thank-you-order-details/instructions-close.svg";
const UnauthorizedAccessModal = () => {
    const navigate = useNavigate();
    const [dismissed, setDismissed] = useState(false);
    const unauthorized = useSyncExternalStore(
        subscribeUnauthorizedAccess,
        getUnauthorizedAccess
    );

    const handleClose = () => {
        setDismissed(true);
        navigate("/logout", { replace: true });
    };

    return (
        <>
            {unauthorized && !dismissed && (
                <div className="unauthorized-access-backdrop">

                    <div className="unauthorized-access-content">
                        <button onClick={handleClose}><img src={CloseIcon} alt="Close" /></button>
                        <div className="unauthorized-access-icon"><img src={icon} alt="Unauthorized access" />  </div>
                        <div className="unauthorized-access-message"><p>Unauthorized access</p></div>
                    </div>

                </div>
            )}

            {/* <Modal show={unauthorized && !dismissed} onHide={handleClose} centered aria-labelledby="unauthorized-access-title">
      <Modal.Header closeButton>
        <Modal.Title id="unauthorized-access-title">Unauthorized access</Modal.Title>
      </Modal.Header>
    </Modal> */}
        </>
    );
};

export default UnauthorizedAccessModal;